<template>
	<v-row align="center">
		<v-col cols="9" class="body-2">
			<p v-if="title" class="title font-weight-medium" v-text="title" />
			<slot />
		</v-col>
		<v-col cols="3">
			<misc-controller-status />
		</v-col>
	</v-row>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: "",
		},
	},
};
</script>
